import * as i0 from "@angular/core";
import * as i1 from "./inbox.service";
export class CleanupService {
    constructor(inboxService) {
        this.inboxService = inboxService;
    }
    doCleanup() {
        //Clear everything needed
        this.inboxService.clearFirebaseEvents();
    }
}
CleanupService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CleanupService_Factory() { return new CleanupService(i0.ɵɵinject(i1.InboxService)); }, token: CleanupService, providedIn: "root" });
